import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl } from '../Utils/api';

function useFetch(url, formData, send) {
  const [Res, setRes] = useState([]);
  const { t } = useTranslation();

  const token = localStorage.getItem("arab_user_token");

  const baseUrl = getApiBaseUrl(t('en'));

  useEffect(() => {
    if (!send) return;

    fetch(`${baseUrl}/${url}`, {
      headers: {
        'Accept': 'application/json',
        // Only send the header when we actually have a token, rather than
        // literally sending "Bearer undefined".
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      },
      method: 'POST',
      body: formData
    })
      .then(async (response) => {
        // fetch() resolves with a Response object — the body still has to be
        // parsed. Reading `.data` off it (as this used to) is always undefined.
        const data = await response.json().catch(() => null);
        setRes(data);
      })
      .catch((error) => {
        console.error(error);
      });
    // `formData` is deliberately NOT a dependency. Callers rebuild a fresh
    // FormData on every render, so its identity always changes — depending on
    // it would re-fire this effect on every render, and because .json() also
    // returns a new object each time, setRes would re-render and loop forever.
    // `send` is the intended trigger; the effect reads whatever formData the
    // triggering render produced.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, send]);

  return [Res, setRes];
}


export default useFetch;
